import { procedureBaseModel } from './crud';

export * from './types';

export const useProceduresById = procedureBaseModel.fetchById();
export const useProceduresByIds = procedureBaseModel.fetchByIds();
export const useProceduresMany = procedureBaseModel.fetchMany();
export const useProceduresCount = procedureBaseModel.count();
export const useProceduresManyInfiniteQuery =
  procedureBaseModel.fetchPaginated();
export const useProceduresUpdateOne = procedureBaseModel.edit();
export const useProceduresCreateOne = procedureBaseModel.create();
export const useProceduresRemoveOne = procedureBaseModel.delete();
export const useProceduresRemoveByIds = procedureBaseModel.deleteByIds();

export const useProceduresByIdV2 = procedureBaseModel.fetchByIdV2();
export const useProceduresByIdsV2 = procedureBaseModel.fetchByIdsV2();
export const useProceduresManyV2 = procedureBaseModel.fetchManyV2();
export const useProceduresCountV2 = procedureBaseModel.countV2();
export const useProceduresManyInfiniteQueryV2 =
  procedureBaseModel.fetchPaginatedV2();
export const useProceduresUpdateOneV2 = procedureBaseModel.editV2();
export const useProceduresCreateOneV2 = procedureBaseModel.createV2();
export const useProceduresRemoveOneV2 = procedureBaseModel.deleteV2();
export const useProceduresRemoveByIdsV2 = procedureBaseModel.deleteByIdsV2();

// New names based on Mongoose queries
export const useProcedureById = procedureBaseModel.fetchById();
export const useProcedureByIds = procedureBaseModel.fetchByIds();
export const useProcedureMany = procedureBaseModel.fetchMany();
export const useProcedureCount = procedureBaseModel.count();
export const useProcedurePagination = procedureBaseModel.fetchPaginated();
export const useProcedureUpdateOne = procedureBaseModel.edit();
export const useProcedureCreateOne = procedureBaseModel.create();
export const useProcedureRemoveOne = procedureBaseModel.delete();
export const useProcedureRemoveByIds = procedureBaseModel.deleteByIds();

export const useProcedureByIdV2 = procedureBaseModel.fetchByIdV2();
export const useProcedureByIdsV2 = procedureBaseModel.fetchByIdsV2();
export const useProcedureManyV2 = procedureBaseModel.fetchManyV2();
export const useProcedureCountV2 = procedureBaseModel.countV2();
export const useProcedurePaginationV2 = procedureBaseModel.fetchPaginatedV2();
export const useProcedureUpdateOneV2 = procedureBaseModel.editV2();
export const useProcedureCreateOneV2 = procedureBaseModel.createV2();
export const useProcedureRemoveOneV2 = procedureBaseModel.deleteV2();
export const useProcedureRemoveByIdsV2 = procedureBaseModel.deleteByIdsV2();
